import React from 'react'
import { Box, Chip, Typography, useTheme } from '@material-ui/core'
import { Attachment } from '../../components'
import type { InventoryInspectionDetail } from '../../hooks/useMoveOutManagement/useMoveOutManagement'

interface InventoryIssueCardProps {
    inventoryInspection: InventoryInspectionDetail
    areaName: string
}

export const InventoryIssueCard: React.FC<InventoryIssueCardProps> = ({
    inventoryInspection,
    areaName,
}) => {
    const theme = useTheme()

    return (
        <Box
            style={{
                border: '1px solid #e5e7eb',
                borderRadius: 8,
                overflow: 'hidden',
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                style={{
                    backgroundColor: '#f8fafc',
                    padding: '10px 16px',
                }}
            >
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                    {inventoryInspection.name}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                    {areaName}
                </Typography>
            </Box>

            <Box style={{ padding: 16 }}>
                {inventoryInspection.issues.map((issue) => (
                    <Box
                        key={issue.id}
                        style={{
                            padding: '8px 0',
                            borderBottom: '1px solid #f1f5f9',
                        }}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            style={{ gap: 8, marginBottom: 4 }}
                        >
                            <Typography variant="body2">
                                {issue.description}
                            </Typography>
                            {issue.creation_type && (
                                <Chip
                                    label={issue.creation_type}
                                    size="small"
                                    style={{
                                        height: 18,
                                        fontSize: '0.6rem',
                                        fontWeight: 600,
                                        backgroundColor: '#f1f5f9',
                                        color: '#64748b',
                                    }}
                                />
                            )}
                        </Box>

                        {issue.attachments.length > 0 && (
                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 8, marginTop: 8 }}
                            >
                                {issue.attachments.map((att) => (
                                    <Attachment
                                        key={att.id}
                                        attachment={att.url}
                                        uploaded={att.uploaded}
                                        theme={theme}
                                        size={80}
                                    />
                                ))}
                            </Box>
                        )}
                    </Box>
                ))}

                {inventoryInspection.attachments.length > 0 && (
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 8, marginTop: 12 }}
                    >
                        {inventoryInspection.attachments.map((att) => (
                            <Attachment
                                key={att.id}
                                attachment={att.url}
                                uploaded={att.uploaded}
                                theme={theme}
                                size={80}
                            />
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    )
}
